

































































































































































































































































































import {
  AuctionManagementAuctionService,
  AuctionManagementLivecarpItemDTO,
  AuctionManagementLivecarpItemMetaDTO,
  AuthService,
  LiveManagementLiveService,
} from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import qNotify from "@/common/qNotify";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import qSelectLives from "@/components/common/qSelectLives.vue";
import { orderBy } from "lodash";
import Multiselect from "vue-multiselect";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "AuctionListComponent",
  components: {
    QMultiSelect,
    QSearch,
    QTableHeader,
    Multiselect,
    QErrors,
    qSelectLives,
  },
})
export default class AuctionListComponent extends Vue {
  public auctions: AuctionManagementLivecarpItemDTO[] = [];
  public meta: AuctionManagementLivecarpItemMetaDTO = {
    producer: [],
    kind: [],
    age: [],
    sex: [],
  };

  public tmp = {
    id: null,
    name: "",
    code: "",
    status: ["bidding"],
    procedure: [],
    kind: [],
    size: [],
    age: [],
    sex: [],
    sort: "code",
    direction: "asc",
  };

  public filter = {
    id: null,
    name: "",
    code: "",
    status: ["bidding"],
    procedure: [],
    kind: [],
    size: [],
    age: [],
    sex: [],
    sort: "code",
    direction: "asc",
  };

  public headers = [
    { id: "code", name: "鯉コード", order: "asc" },
    { id: "end_datetime", name: "締切日時", order: "" },
    { id: "end_datetime", name: "残り時間", order: "" },
    { id: "", name: "鯉情報" },
    { id: "current_price", name: "現在価格", order: "" },
    { id: "highest_bid_price", name: "最高入札額" },
    { id: "", name: "最高入札者" },
    { id: "", name: "落札価格" },
    { id: "", name: "入札状況" },
  ];

  public statuses = [
    { id: "before_bidding", name: "開始前" },
    { id: "bidding", name: "入札中" },
    { id: "end_bidding", name: "入札終了" },
    { id: "cancel", name: "中止" },
  ];

  public sizes = [
    { id: "0", name: "〜10cm" },
    { id: "1", name: "11cm〜20cm" },
    { id: "2", name: "21cm〜30cm" },
    { id: "3", name: "31cm〜40cm" },
    { id: "4", name: "41cm〜50cm" },
    { id: "5", name: "51cm〜60cm" },
    { id: "6", name: "61cm〜70cm" },
    { id: "7", name: "71cm〜80cm" },
    { id: "8", name: "80cm〜" },
  ];

  public openBidHistories = [];
  public bidEditor = null;
  public bidPrice = null;
  public errors = {};
  public liveCarpList = [];
  public liveCarpListOption = [];
  public livecarp = null;

  public connection: WebSocket;
  public connectionId = null;
  public waitRefresh = false;

  public resetSearch() {
    this.livecarp = null;
    this.filter.id = null;
    this.filter.name = "";
    this.filter.code = "";
    this.filter.status = ["bidding"];
    this.filter.procedure = [];
    this.filter.kind = [];
    this.filter.sex = [];
    this.filter.size = [];
    this.filter.sex = [];
    this.filter.age = [];
    this.search();
  }

  public async mounted() {
    const currentQuery = this.$router.currentRoute.query;

    if (currentQuery.status) {
      const status = currentQuery.status;
      if (typeof status === "string") {
        this.tmp.status = [currentQuery.status as string];
      } else if (typeof status === "object") {
        this.tmp.status = currentQuery.status as string[];
      }
    }

    if (currentQuery.procedure) {
      const procedure = currentQuery.procedure;
      if (typeof procedure === "string") {
        this.tmp.procedure = [currentQuery.procedure];
      } else if (typeof procedure === "object") {
        this.tmp.procedure = currentQuery.procedure as string[];
      }
    }

    if (currentQuery.kind) {
      const kind = currentQuery.kind;
      if (typeof kind === "string") {
        this.tmp.kind = [currentQuery.kind];
      } else if (typeof kind === "object") {
        this.tmp.kind = currentQuery.kind as string[];
      }
    }

    if (currentQuery.sex) {
      const sex = currentQuery.sex;
      if (typeof sex === "string") {
        this.tmp.sex = [currentQuery.sex];
      } else if (typeof sex === "object") {
        this.tmp.sex = currentQuery.sex as string[];
      }
    }

    if (currentQuery.size) {
      const size = currentQuery.size;
      if (typeof size === "string") {
        this.tmp.size = [currentQuery.size];
      } else if (typeof size === "object") {
        this.tmp.size = currentQuery.size as string[];
      }
    }

    if (currentQuery.age) {
      const age = currentQuery.age;
      if (typeof age === "string") {
        this.tmp.age = [currentQuery.age];
      } else if (typeof age === "object") {
        this.tmp.age = currentQuery.age as string[];
      }
    }

    if (currentQuery.direction) {
      this.filter.direction = String(currentQuery.direction);
    }

    if (currentQuery.sort) {
      this.filter.sort = String(currentQuery.sort);
    }

    await this.getLivecarpItems();
    this.livecarp = this.liveCarpListOption[0];
    this.filter.id = this.livecarp?.id;
    if (currentQuery.id) {
      this.tmp.id = Number(currentQuery.id);
      this.livecarp = this.liveCarpList.find(
        (object) => object.id === this.tmp.id,
      );
    } else {
      this.tmp.id = this.livecarp?.id;
    }

    if (currentQuery.code) {
      this.tmp.code = String(currentQuery.code);
    }

    this.getAuctionMeta();
    this.init();

    setInterval(() => {
      const observableArray = Object.values(this.auctions);
      for (const auction of observableArray) {
        const remainingTimeElement = document.querySelector(
          "#remainingTime-" + auction.id,
        );
        if (remainingTimeElement) {
          remainingTimeElement.textContent = this.calculateRemainingTime(
            auction.end_datetime,
          );
        }
      }
    }, 1000);
  }

  public async init() {
    let query: any = {
      id: this.filter.id,
      code: this.filter.code,
      procedure: this.filter.procedure,
      kind: this.filter.kind,
      size: this.filter.size,
      age: this.filter.age,
      sex: this.filter.sex,
      sort: this.filter.sort,
      direction: this.filter.direction,
      status: this.filter.status.join(","),
    };

    query = {
      ...query,
      status: this.filter.status,
    };

    await this.getAuction(query);
    this.connectSocket();
  }

  public async search(query: any = {}) {
    this.unSubsclibe();
    this.filter.id = this.livecarp?.id ?? "";
    const newQuery = {
      id: this.filter.id,
      code: this.filter.code,
      status: this.filter.status,
      procedure: this.filter.procedure,
      kind: this.filter.kind,
      sex: this.filter.sex,
      age: this.filter.age,
      size: this.filter.size,
      sort: this.filter.sort,
      direction: this.filter.direction,
      ...query,
    };

    this.$router.push({ query: newQuery });

    query = {
      ...this.filter,
      ...query,
    };

    await this.getAuction(query);
    this.subsclibe();
    this.closeAllBidWindows();
  }

  public calculateRemainingTime(targetDate) {
    const timeZone = "Asia/Tokyo"; // Set the timezone to Japan (Tokyo)
    const currentTimeJP = new Date().toLocaleString("en-US", { timeZone });
    const currentTime = new Date(currentTimeJP).getTime();
    targetDate = new Date(targetDate).getTime();
    const timeDifference = targetDate - currentTime;

    if (timeDifference <= 0) {
      return "--";
    } else {
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours =
        Math.floor(
          (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        ) +
        days * 24;
      const minutes = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60),
      );
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      return `${this.formatTime(hours)}:${this.formatTime(
        minutes,
      )}:${this.formatTime(seconds)}`;
    }
  }

  public formatTime(time) {
    return time < 10 ? "0" + time : time;
  }

  public openBidHistory(id) {
    if (!this.openBidHistories.includes(id)) {
      this.openBidHistories.push(id);
    }
  }

  public openBidEditor(id) {
    this.bidEditor = id;
  }

  public closeBidHistory(id) {
    if (this.openBidHistories.includes(id)) {
      const index = this.openBidHistories.indexOf(id);
      this.openBidHistories.splice(index, 1);
    }
  }

  public async closeBidEditor() {
    this.bidEditor = null;
    this.bidPrice = null;
    this.errors = {};
    if (this.waitRefresh) {
      this.waitRefresh = false;
      this.refreshWithHistories();
    }
  }

  public closeAllBidWindows() {
    this.openBidHistories = [];
    this.closeBidEditor();
  }

  public submitBidEditor(livecarp_item_bids) {
    const livecarpItemBidId = orderBy(livecarp_item_bids, "price", "desc")[0]
      .id;
    AuctionManagementAuctionService.adminAuctionEditBid({
      livecarpItemBidId,
      price: this.bidPrice * 1000,
    })
      .then(() => {
        QNotify.success({ text: "入札額を編集しました。" });
        this.closeBidEditor();
        this.search();
      })
      .catch((error) => {
        console.log(error);
        QNotify.error({
          text: error.body.message ?? "入札額の編集に失敗しました。",
        });

        this.errors = error.body.errors;
      });
  }

  public async getAuction(query) {
    try {
      const result = await AuctionManagementAuctionService.adminAuction(query);

      this.auctions = result.data.auctions;
    } catch (error) {
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public async getAuctionMeta() {
    try {
      this.filter.id = this.tmp.id;
      this.filter.procedure = this.tmp.procedure;
      this.filter.kind = this.tmp.kind;
      this.filter.size = this.tmp.size;
      this.filter.sex = this.tmp.sex;
      this.filter.age = this.tmp.age;
      this.filter.code = this.tmp.code;
      this.filter.status = this.tmp.status;
      const result = await AuctionManagementAuctionService.adminAuctionMeta({});
      this.meta = result.data.meta;
    } catch (error) {
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public getUsername(livecarp_item_bid) {
    return `${livecarp_item_bid.livecarp_item_tenderer?.member?.first_name}${livecarp_item_bid.livecarp_item_tenderer?.member?.last_name}`;
  }
  public min(argument1, argument2) {
    return argument1 < argument2 ? argument1 : argument2;
  }

  public async exportCsv() {
    try {
      const query = {
        ...this.filter,
      };

      const result: any = await AuctionManagementAuctionService.adminAuctionCsv(
        query,
      );
      const aTag = document.createElement("a");
      aTag.href = result.data.url;
      aTag.target = "_blank";
      document.body.append(aTag);
      aTag.click();
      aTag.remove();
    } catch (error) {
      console.log(error);
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public async getLivecarpItems() {
    this.liveCarpList = [];
    const result: any = await LiveManagementLiveService.adminLiveListForSelect(
      {},
    );
    this.liveCarpList = result.data.livecarp;
    this.liveCarpListOption = [...this.liveCarpList.slice(0, 1)];
  }

  public async connectSocket() {
    const result = await AuthService.connectSocketUrl({});
    this.connection = new WebSocket(result.data.connect_socket_url);
    this.connection.addEventListener("message", (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      if (data.action === "subcribe") {
        this.connectionId = data.connectionId;
      } else if (
        data.action === "publish" &&
        this.connectionId !== data.connectionId &&
        data.event === "LivecarpItemChanged"
      ) {
        this.updateItem(data);
      }
    });
    this.connection.addEventListener("open", () => {
      const body = {
        action: "subscribe",
        topic: `no1koi/livecarpWithPrice/${this.filter.id}`,
      };
      this.connection.send(JSON.stringify(body));
    });
  }
  public async disconnectSocket() {
    this.unSubsclibe();
    this.connection.close();
  }

  public subsclibe() {
    if (this.connection.readyState === WebSocket.OPEN) {
      const body = {
        action: "subscribe",
        topic: `no1koi/livecarpWithPrice/${this.filter.id}`,
      };
      this.connection.send(JSON.stringify(body));
    } else {
      this.connectSocket();
    }
  }

  public unSubsclibe() {
    if (this.connection.readyState === WebSocket.OPEN) {
      const body = {
        action: "unSubscribe",
        topic: `no1koi/livecarpWithPrice/${this.filter.id}`,
      };
      this.connection.send(JSON.stringify(body));
    }
  }

  public async updateItem(data) {
    console.log(data);
    if (this.bidEditor) {
      this.waitRefresh = true;
      qNotify.success({
        text: "最高価格の更新がありました。",
      });
    } else {
      this.refreshWithHistories();
    }
  }

  public async refreshWithHistories() {
    const histories = this.openBidHistories;
    await this.search();
    histories.map((row) => {
      this.openBidHistory(row);
    });
    this.openBidHistories = histories;
  }

  public async beforeDestroy() {
    this.disconnectSocket();
  }
}
